import React, { useState } from 'react';
import styles from './edit-image-component.module.scss';
import { CircleImage, DefaultButton, InputImage } from 'shared/ui';
import handleFileChange from '../model/handle-file-change';
import { ContentApi } from 'shared/api/content/model/content';

interface IEditImageComponentProps {
  setUrl: (url: string) => void;
}
export const EditImageComponent: React.FC<IEditImageComponentProps> = ({
  setUrl,
}) => {
  const SIZES = [90, 50, 35, 25];
  const [validationError, setValidationError] = useState('');
  const [preview, setPreview] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const onFileChange = handleFileChange(
    setPreview,
    setFile,
    setValidationError
  );
  const handleSubmit = async (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (!file) {
      setValidationError('Сначала выберите файл');
      e.stopPropagation();
      return;
    }

    try {
      setIsLoading(true);
      const imageUrl = await ContentApi.createImage({ file });
      setUrl(imageUrl);
    } catch (error) {
      e.stopPropagation();
      setValidationError(
        error instanceof Error
          ? error.message
          : 'Ошибка при загрузке изображения'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={styles.edit_image__container}
      onClick={(e) => {
        if ((e.target as HTMLElement).closest(`.${styles.buttons__button}`)) {
          handleSubmit(e);
          return;
        }
        e.stopPropagation();
      }}
    >
      <div className={styles.container__title}>Изменение изображения</div>
      <div className={styles.container__input_button}>
        <InputImage onChange={onFileChange} />
      </div>
      <div className={styles.container__preview_title}>Предпросмотр</div>
      {preview ? (
        <div className={styles.container__preview_images}>
          {SIZES.map((size) => (
            <CircleImage key={size} imgSize={size} imgSrc={preview} />
          ))}
        </div>
      ) : (
        <div className={styles.container__preview_empty}>
          Выберите изображение для предпросмотра
        </div>
      )}
      {validationError ? (
        <div className={styles.content__error}>{validationError}</div>
      ) : null}
      <div className={styles.container__buttons}>
        <div className={styles.buttons__button}>
          <DefaultButton
            buttonText={isLoading ? 'Загрузка...' : 'Сохранить'}
            className={styles.button_save}
            color="green"
          />
        </div>
      </div>
    </div>
  );
};
